import PATH_PAGE from '@/router/path';
import { WORKSPACE_STATUS } from '@/service/workspace/constants';
import { useGetWorkspaces } from '@/service/workspace/hook';
import { Navigate } from 'react-router-dom';

const Workspaces = () => {
  const { data, isLoading } = useGetWorkspaces();

  if (isLoading) {
    return (
      <div className="flex h-screen items-center justify-center">
        <div className="text-muted-foreground">Loading...</div>
      </div>
    );
  }

  // Find default workspace or use the first one
  const defaultWorkspace = data?.find(
    (workspace) => workspace.workspace_status === WORKSPACE_STATUS.DEFAULT
  ) || data?.[0];

  if (defaultWorkspace?.workspace_id) {
    return (
      <Navigate
        to={PATH_PAGE.dashboard.workspaceById(defaultWorkspace.workspace_id)}
        replace
      />
    );
  }

  // Fallback to profile if no workspace found
  return <Navigate to={PATH_PAGE.setting.profile} replace />;
};

export default Workspaces;
